import { SkillEndorsementApi, StatisticsApi } from "../Api";
import { getAuthConfiguration } from "./configuration";

const StatisticsApiFactory = () => new StatisticsApi();

export const getLandingPageStatistics = () => {
	return StatisticsApiFactory().apiStatisticsGetLandingPageStatisticsGet();
};
